<script lang="ts">
  import { PageSection } from '@stickerapp-org/athena/Page';
  import { StoryblokComponent, storyblokEditable } from '@storyblok/svelte';
  import { Stack, StackItem } from '@stickerapp-org/athena/Stack';
  import type { PageSectionBlock } from '@storyblok-types';
  import clsx from 'clsx';
  const { blok }: { blok: PageSectionBlock } = $props();
</script>

<PageSection
  id={blok.elementId}
  action={storyblokEditable}
  actionArg={blok}
  width={blok.width || 'full'}
  backgroundColor={blok.backgroundColor || 'light'}
  backgroundMediaUrl={blok.backgroundMedia?.filename}
  ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
  class={clsx('scroll-smooth', blok.displayNone && 'hidden')}
>
  <Stack space={blok.bodySpace || 'gutter'}>
    {#each blok.body ?? [] as item (item._uid)}
      <StackItem>
        <StoryblokComponent blok={item} />
      </StackItem>
    {/each}
  </Stack>
</PageSection>
